<section id="header">
    <app-header></app-header>
</section>
<router-outlet></router-outlet>
<section id="footer">
    <app-footer></app-footer>
</section>
